export default {
	namespaced: true,

	state: {
		dummy: {
			order: 1,
			title: 'Dummy Sales Title',
			subTitle: 'Dummy Sales Sub Title',
			text: 'Dummy Sales Text',

			bigImage: {
				url: 'DummyImage'
			},

			image: {
				url: 'DummyImage'
			},

			products: {
				dummyProduct1: {
					order:1,
					title: 'Dummy Product Title1',
					text: 'Dummy Product Text1',

					image: {
						url: 'DummyImageProduct'
					},

					// actionButtons: {
					// 	action: {
					// 		title: 'Action',
					// 		order: 10
					// 	}
					// },

					price: 10000
				},
				dummyProduct2: {
					order:2,
					title: 'Dummy Product Title2',
					text: 'Dummy Product Text2',

					image: {
						url: 'DummyImageProduct'
					},

					// actionButtons: {
					// 	action: {
					// 		title: 'Action',
					// 		order: 10
					// 	}
					// },

					price: 30000
				},
				dummyProduct3: {
					order:3,
					title: 'Dummy Product Title3',
					text: 'Dummy Product Text3',

					image: {
						url: 'DummyImageProduct'
					},

					price: 50000,
	
					serialNumbers: {
						dummyProduct3SerialNumber1: {
							order: 1,
							status: {
								opened: true
							}
						},
						dummyProduct3SerialNumber2: {
							order: 2,
							status: {
								opened: true
							}
						},
						dummyProduct3SerialNumber3: {
							order: 3,
							status: {
								opened: true
							}
						}
					}
				}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
